import { type ReactElement } from 'react';
import { isPermissionRefused } from '@citibox-panel/api-client';
import { AmazonDoorAccessPage } from '@citibox-panel/lockers-operations';
import {
  fetchDoorAccessCount,
  fetchDoorAccessLocation,
  setDoorAccessForLocations,
} from '@/lib/apiClient';
import { useIsArrival } from '@/lib/arrival';
import { MARKET_LABELS, resolveMarket } from '@/lib/marketIndicator';
import { readRuntimeConfig } from '@/lib/runtimeConfig';

// The composition root for the operations screen: it resolves the market and picks the reads and
// the write, so the module stays free of any apps/shell dependency and knows neither its own URL
// nor whether it is talking to a mock. The band around it is the Producto layout's.
export function AmazonDoorAccessRoute(): ReactElement {
  const arrived = useIsArrival();
  const market = resolveMarket(readRuntimeConfig());
  // The bare label the confirmation needs («ES»); `null` when the deployment cannot be trusted to
  // name its market, so the dialog says so rather than printing a dash.
  const marketLabel = market === null ? null : MARKET_LABELS[market];

  return (
    <AmazonDoorAccessPage
      fetchDoorAccessCount={fetchDoorAccessCount}
      setDoorAccess={setDoorAccessForLocations}
      fetchDoorAccessLocation={fetchDoorAccessLocation}
      // A Rechazo por permiso already has the host's access screen, so the cards stay quiet on it.
      isHandledByHost={isPermissionRefused}
      marketLabel={marketLabel}
      focusHeadingOnArrival={arrived}
    />
  );
}
